import { Container, Row } from "reactstrap";
import AjaxSourcedData from "./AjaxSourcedData";
import HtmlSourcedData from "./HtmlSourcedData";
import JavascriptSourcedData from "./JavascriptSourcedData";
import ServerSideProcessing from "./ServerSideProcessing";
import { DATASourceDataTablesTitle, DataTitle } from "../../../../../constants";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const DataSourceContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={DATASourceDataTablesTitle} parent={DataTitle} />
      <Container fluid>
        <Row>
          <HtmlSourcedData />
          <AjaxSourcedData />
          <JavascriptSourcedData />
          <ServerSideProcessing />
        </Row>
      </Container>
    </>
  );
};
export default DataSourceContainer;
